import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { IPaginatedStoreWithItems } from '@planning/stores/PaginatedStore'
import { observer } from 'mobx-react-lite'
import { ReleaseDetailsViewStore } from '../../../Stores/ReleaseDetailsViewStore'
import { NonNumericReleaseDetailsTableActions } from '../../atoms/NonNumericReleaseDetailsTableActions'
import { ReleaseDetailsTable } from '../../molecules/ReleaseDetailsTable'
import { NonNumericReleaseAssignOrderDialog } from './NonNumericReleaseAssignOrderDialog'

interface Props {
  viewStore: ReleaseDetailsViewStore
  nnrOrder: INonNumericReleaseItem
  orderStore: IPaginatedStoreWithItems<IOrderItem>
}

export const NonNumericReleaseDetailsTable = observer((props: Props) => {
  const { nnrOrder, orderStore, viewStore } = props

  if (!nnrOrder) return <></>

  const sx = nnrOrder.isExpired
    ? { maxHeight: 'calc(100vh - 390px)', minHeight: 'calc(100vh - 390px)' }
    : { maxHeight: 'calc(100vh - 320px)', minHeight: 'calc(100vh - 320px)' }

  return (
    <>
      <ReleaseDetailsTable
        items={orderStore.pageItems}
        viewStore={viewStore}
        sx={sx}
        renderRowActions={({ row }) => (
          <NonNumericReleaseDetailsTableActions
            row={row}
            viewStore={viewStore}
            nnrOrder={nnrOrder}
          />
        )}
      />
      <NonNumericReleaseAssignOrderDialog
        isOpen={viewStore.isAssignDialogOpen}
        onClose={() => {
          viewStore.setIsAssignDialogOpen(false)
        }}
        nnrOrder={nnrOrder.data}
        orderId={viewStore.selectedOrder?.id}
        order={viewStore.selectedOrder}
      />
    </>
  )
})
